<template>
    <div class="flex mt-8 justify-center items-center">
        <!-- Time Display -->
        <div class="text-white text-8xl mr-10">
            {{ displayTime }}
        </div>

        <!-- Divider -->
        <div class="w-1 h-20 bg-white rounded-xl"></div>

        <!-- Status Information -->
        <div class="ml-6">
            <!-- Free Status -->
            <p
                v-if="occupationStatus === 'free'"
                class="text-room-green text-5xl"
            >
                Frei
            </p>

            <!-- Soon Occupied Status -->
            <p
                v-if="occupationStatus === 'soonOccupied'"
                class="text-room-green text-3xl"
            >
                Frei
            </p>

            <!-- Occupied Status -->
            <p
                v-if="occupationStatus === 'occupied'"
                class="text-room-red text-5xl"
            >
                {{ nextBooking.event?.title ?? "Besetzt" }}
            </p>

            <!-- Booking Details (when occupied) -->
            <div v-if="nextBooking && occupationStatus === 'occupied'">
                <p class="text-white text-3xl">
                    {{ extractTime(nextBooking.start) }}
                    -
                    {{ extractTime(nextBooking.end) }}
                </p>
                <p v-if="nextBooking.display_name" class="text-white text-2xl">
                    {{ nextBooking.display_name }}
                </p>
                <p v-show="nextBooking.checked_in_at" class="text-room-green text-2xl">
                    (Eingecheckt)
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import {extractTime} from "../../utils/conferenceRoomTime";

export default {
    name: "RoomStatusDisplay",

    props: {
        timestamp: {
            type: String,
            required: true,
        },
        occupationStatus: {
            type: String,
            required: true,
            validator: (value) => ['free', 'occupied', 'soonOccupied'].includes(value),
        },
        nextBooking: {
            type: Object,
            default: null,
        },
    },

    computed: {
        displayTime() {
            return this.timestamp.slice(0, 5);
        },
    },

    methods: {
        extractTime,
    },
};
</script>

<style scoped>
/* Flexbox */
.flex {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}
.justify-center {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}
.items-center {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}

/* Text Colors */
.text-white {
    color: #ffffff;
}
.text-room-green {
    color: #22c55e;
}
.text-room-red {
    color: #ef4444;
}

/* Text Size */
.text-8xl {
    font-size: 6rem;
    line-height: 1;
}
.text-5xl {
    font-size: 3rem;
    line-height: 1;
}
.text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
}
.text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
}

/* Spacing */
.mt-8 {
    margin-top: 2rem;
}
.mr-10 {
    margin-right: 2.5rem;
}
.ml-6 {
    margin-left: 1.5rem;
}

/* Sizing */
.w-1 {
    width: 0.25rem;
}
.h-20 {
    height: 5rem;
}

/* Background Colors */
.bg-white {
    background-color: #ffffff;
}

/* Border Radius */
.rounded-xl {
    -webkit-border-radius: 0.75rem;
    -moz-border-radius: 0.75rem;
    border-radius: 0.75rem;
}
</style>
